/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBTRANSACTIONTYPE = {
    PolicyCancelled: 'PCAN',
    PolicyPayerChange: 'PYCH',
    BenefitStatement: 'BFST',
    PremiumCollection: 'PCOL',
    AutoRebalance: 'RBAT',
    AibaUpdated: 'PORT',
    PartRetirement: 'PRTR',
    PartialSwitchRequest: 'PSWQ',
    FiscalLetter: 'FSLT',
    FxCharge: 'FXCG',
    CancellationForNonPayment: 'CNP',
    RegularWithdrawalPending: 'REGWP',
    FxChargeReversal: 'FXCR',
    RegularWithdrawal: 'WITH',
    PolLostDeclarationEncashment: 'LPDE',
    DdAuthorisationRejected: 'ATRJ',
    AutomaticSwitch: 'AUTOSWT',
    ClusterManagement: 'CMAN',
    BatchCashClearance: 'BCCL',
    PremiumIndexation: 'PRIX',
    AddresseeChange: 'AECH',
    ClaimsInterimPayment: 'INPY',
    SwitchAutoRebalanceOn: 'RBON',
    TrailCommission: 'PDFC',
    BeneficiaryRemoved: 'BNYR',
    SwitchOrRedirectionRequest: 'SRDQ',
    AssignmentCancellation: 'CAS',
    SwitchOrRedirection: 'SWRD',
    AssignmentAmended: 'ASSE',
    AnnualManagementCharge: 'AMC',
    DeathClaimRegistered: 'DTHR',
    AttachNewAddress: 'ATNA',
    AssignmentAcknowledgement: 'AAS',
    AssignmentRemoved: 'ASSR',
    AddDsaIntermediary: 'IADSA',
    DsaCommission: 'CDSA',
    SinglePremiumTopUpNotProvidedWith: 'SPIN',
    UnitAdjustmentConversion: 'UCNV',
    PensionAdjOrderMaintenance: 'PADJMNT',
    FundDividend: 'UAFD',
    RetirementClaimRequest: 'RTRP',
    PaymentAuthorisation: 'PAUT',
    BeneficiaryAmended: 'BNYE',
    SinglePremiumTopUp: 'SPI',
    DisContribAdjustment: 'SCA',
    NewBusiness: 'NWB',
    Reinstatement: 'REIN',
    PremiumArrearCancellation: 'PARC',
    PartSurrender: 'PSU',
    BillingMethodChange: 'BMCH',
    SetInforce: 'SIF',
    Proposal: 'PROP',
    PremiumHolidayCancel: 'PHOC',
    ArrearCreated: 'ARR',
    SwitchRequestCancelled: 'SWCA',
    SinglePremiumTopUpCancellation: 'SPCN',
    _2NdNonPaymentInstruction: 'BNPI',
    SwitchRequest: 'SWTQ',
    LifecycleOptionSwitchedOff: 'LSOF',
    WindbackToProposal: 'PWBK',
    DeathClaimApproved: 'DTHA',
    Attribution: 'ATTR',
    PartRetirementClaimRequest: 'PRTRP',
    RecalcFundingFactor: 'RCFF',
    RemoveFpsIntermediary: 'IRFPS',
    PartSurrenderFee: 'PSCH',
    ArrearsPaymentPlan: 'PASR',
    MoneyboxOptionSwitchedOn: 'MBON',
    RegularPremiumDecrease: 'RPDE',
    RegularWithdrawalSetup: 'WITR',
    PartialSwitch: 'PSWT',
    ChangeApprefAdminCancel: 'APRC',
    SumAssuredDecrease: 'SADE',
    MaturityClaim: 'MTR',
    UnitStatement: 'UNST',
    _1StNonPaymentInstruction: 'ANPI',
    RiskSetInForce: 'RSIF',
    PremiumIndexationSwitchedOff: 'PIX_OFF',
    UnitAdjustment: 'UNAD',
    LifecycleOptionSwitchedOn: 'LSON',
    LifecyclePortfolioRebalance: 'LSTL',
    LeaverMoreThanTwoYears: 'LMO',
    MoneyboxOptionSwitchedOff: 'MBOF',
    UnitCancellation: 'UCAN',
    PolicyIndexationRateChange: 'IXCH',
    AutoSwitchDisabled: 'NOAU',
    RiderBenefitClaim: 'RDR',
    CancelledFromInception: 'CFI',
    RedirectionOnly: 'SROY',
    PremiumChangeDueToIndexationNotice: 'PCIN',
    RegularWithdrawalRequest: 'REGWR',
    AdminCancel: 'ACAN',
    SwitchAutoRebalanceOff: 'RBOF',
    AuthorisationAwaiting: 'ATAW',
    DdAuthorisationRequest: 'ATRQ',
    LeaverLessTwoYears: 'LLE',
    TrackerStatement: 'TKST',
    BatchCashNotification: 'CNOT',
    MaturityClaimPending: 'MTRP',
    BulkSwitch: 'BULKSWT',
    NewBusinessReview: 'NWBR',
    AccountDetailsChange: 'BADC',
    SinglePremiumTopUpCancellationCapture: 'SPICC',
    PolicyLapseFinalisation: 'LAPS',
    PremiumPayments: 'PPAY',
    PremiumChangeDueToIndexationConfirmation: 'PCIC',
    BillingFrequencyChange: 'BFCH',
    BillingStartDateChange: 'BDCH',
    AdministrationCharge: 'ADCH',
    SwitchFeesDisabled: 'SFOF',
    RemoveDsaIntermediary: 'IRDSA',
    BeneficiaryAdded: 'BNYA',
    BatchCashInput: 'CINP',
    RiskAdded: 'RAWP',
    PolicyMigrated: 'PCONC1',
    AddFpsIntermediary: 'IAFPS',
    PrivMedicalAttnRptExistingClient: 'PMRE',
    AdHocRebalance: 'RBAD',
    BeneficiaryStatement: 'BNST',
    SinglePremiumTopUpSetInforce: 'SPIS',
    PaymentOut: 'PAYM',
    DeathClaim: 'DTH',
    DdAuthorisationAccepted: 'ATAC',
    PolicyOwnerChange: 'POCH',
    WithdrawalPayment: 'WTHP',
    AuthorisationNotRequired: 'ATNR',
    TrustChargesRequest: 'TCSP',
    TransferPremiumReview: 'TRFR',
    PremiumRefund: 'PRFD',
    BeneficiaryChange: 'BNCH',
    PolicyHasRetired: 'RTRD',
    AddALife: 'ALIF',
    ManualPremiumPayment: 'MPAY',
    ConsumerPriceIndex: 'CPI',
    LifeAssuredChange: 'LACH',
    PremiumIndexationSwitchedOn: 'PIX_ON',
    AdminCancelRefund: 'ACAR',
    ManualPremiumRejection: 'PRMR',
    RenewalNotice: 'RENO',
    AuthorisationSuspended: 'ATAS',
    PolLostDeclarationNewDocs: 'LPDN',
    FullSurrenderRequest: 'SURP',
    FpsCommission: 'CFPS',
    SinglePremiumTopUpReview: 'SPIR',
    TrustCharges: 'TCS',
    SetApprovedPending: 'SAP',
    PrivMedicalAttnRptNewClient: 'PMRN',
    ClientDetailsChanged: 'CPDT',
    PremiumHoliday: 'PHOL',
    CommissionPayment: 'COMP',
    SumAssuredIncrease: 'SAIN',
    PolicyRevoked: 'REVO',
    QuotationPack: 'QPK',
    Windback: 'WIND',
    PolicyNotes: 'NOTC',
    AutomaticPremiumPayment: 'PAAY',
    FullSurrender: 'SUR',
    PolicyFee: 'PFEE',
    PolicyHasMatured: 'MTRD',
    AssignmentAdded: 'ASSA',
    CashTransfer: 'CTRN',
    PremiumIndexationCancelled: 'PIX_CAN',
    PolicyPaidUp: 'PDUP',
    RiskCharging: 'RSCG',
    CancelledFromInceptionRefund: 'CFIR',
    PrivMedicalAttnRptPayment: 'PMRP',
    StatementOfResidence: 'SOR',
    CoolOff: 'COOL',
    ChangeBilling: 'BILC',
    BonusReserve: 'BNRE',
    CouponPayment: 'COUP',
    TransferToSuspense: 'TRFS',
    DisinvestmentOnDeathNotification: 'DNDINV',
    MoneyboxPortfolioRebalance: 'MBOX',
    PolicyLapsed: 'LPSE',
    ManualCommissionAdjustment: 'MCAD',
    PolicyValuation: 'PVAL',
    InitialCharge: 'INCH',
    IntermediaryPolicyTransfer: 'INPT',
    TransferIn: 'TRIN',
    Increase: 'INCR',
    RiskRemoved: 'RRWP',
    ClientAddressChange: 'CPAC',
    NotProceededWith: 'NPW',
    RetirementClaim: 'RTR',
    BatchCashDelete: 'BDEL',
    AdminCancelUnitCancellation: 'ADMC',
    AccountTransfer: 'ATR',
    RegularPaymentSuspended: 'WITS',
    RetirementDateChange: 'REDC',
    SwitchFeesEnabled: 'SFON',
    Switch: 'SWIT',
    FrequencyChange: 'FRCH',
    Decrease: 'DECR',
    PolicyTrusteeChange: 'TECH',
    PartSurrenderRequest: 'PSUP',
    AutoSwitchDisabledSpi: 'NOSPIAU',
    RegularPremiumIncrease: 'RPIN',
    IntBulkSwitchRequest: 'IBSQ',
    Suspension: 'SUS',
    ClientDetailsAmended: 'CLTC',
    Assignment: 'ASSN',
    CancelBonusReserves: 'CBRU',
    CashInputReceipt: 'CASHREC',
    PolicyStatusChange: 'PLST',
    Quote: 'QUOT',
    TransferPremium: 'TRF',
    CoolOffRefund: 'COOR',
    ComplimentarySwitch: 'FSWT',
    RedirectionOnlyRequest: 'SROQ',
    RegularWithdrawalSuspended: 'REGWS',
    AdbCharge: 'RS_ADB',
    RegularPaymentPending: 'WITP',
    InternalTransfer: 'INTR',
    ApplyGovSsiaContribution: 'GOVP',
    PremiumRejection: 'RIDR'
} as const;
export type GHUBTRANSACTIONTYPE = typeof GHUBTRANSACTIONTYPE[keyof typeof GHUBTRANSACTIONTYPE];


export function GHUBTRANSACTIONTYPEFromJSON(json: any): GHUBTRANSACTIONTYPE {
    return GHUBTRANSACTIONTYPEFromJSONTyped(json, false);
}

export function GHUBTRANSACTIONTYPEFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBTRANSACTIONTYPE {
    return json as GHUBTRANSACTIONTYPE;
}

export function GHUBTRANSACTIONTYPEToJSON(value?: GHUBTRANSACTIONTYPE | null): any {
    return value as any;
}

